import { useState } from "react";
import { GoabSpacer, GoabButtonGroup, GoabButton, GoabModal } from "@abgov/react-components";
import { SaveAndFinishLaterButton } from "./SaveAndFinishLaterButton";
import { InternalApplicationStatuses } from "../../../MPP-Common-SPA/common/constants/statuses";
import { isPortalActive } from "../../../MPP-Common-SPA/utils/globalUtility";
import { useUnsavedChanges } from "../../../MPP-Common-SPA/common/unsavedChangesContext";
import { flushSync } from 'react-dom';


import { useLogin } from "../../hooks/useLogin"
import { getLoggedOutEndpoint } from "../../../ServiceUtils/auth";
import { URL_SEARCH_PARAMS } from "../../../MPP-Common-SPA/common/constants/urlParams";

const StepActionButtons = (input) => {
  const { handleLogout } = useLogin();

  const { clearDirty } = useUnsavedChanges();

  const {
    getResourceValue,
    saveStepData,
    moveToReviewStep,
    getFormValues,
    internalStatus,
    programEvents,
    portal,
    user,
    onNext,
    onPrevious,
    handleSubmit,
    inReviewMode,
    currentStep,
    templateForm,
    stepName,
    isEventsEnabled,
    isActiveEvent,
    selectedEvent,
    programEventMapping
  } = input;

  const {
    renderer: { props } = {},
  } = currentStep ?? {};

  const { nextButtonLabel, cancelButtonLabel, hideNextButton, disableNextButton, isTermsOfUse } = props ?? {};

  const [confirmCancel, setConfirmCancel] = useState(false);

  const canShowButtons = isPortalActive(portal, user) && 
    (isEventsEnabled === undefined || !isEventsEnabled || (isEventsEnabled && isActiveEvent));

  const handleNext = async () => {
    if (handleSubmit) {
      await handleSubmit();
      if (Object.keys(templateForm.errors)?.length === 0) {
        requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: "smooth" }));
      }
    } else {
      await onNext(getFormValues());
    }
  };

  const handleSave = async () => {
    if (handleSubmit) {
      await handleSubmit();
    } else {
      saveStepData(getFormValues());
      moveToReviewStep();
    }
  }

  const onConfirmCancel = () => {   
    const url = new URL(window.location.href);
    const code = url.searchParams.get(URL_SEARCH_PARAMS.Code);
    const stepNameFromUrl = url.searchParams.get(URL_SEARCH_PARAMS.Step);
    

    if (!templateForm.dirty) {
      code && stepNameFromUrl ? handleLogout(getLoggedOutEndpoint()) : moveToReviewStep();  
      setConfirmCancel(false);         
    }
    else{
    setConfirmCancel(true);
    }
  }

  const handleCancel = async () => {
    if (saveStepData) {
      saveStepData(getFormValues());
    }
    await onPrevious();
    requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: "smooth" }));
  }

   const onCancel = () => {
    
    const url = new URL(window.location.href);
    const code = url.searchParams.get(URL_SEARCH_PARAMS.Code);
    const stepNameFromUrl = url.searchParams.get(URL_SEARCH_PARAMS.Step);

    // redirect back to the internal portal for proxy user
    if (code && stepNameFromUrl) {
        flushSync(() => {
          clearDirty();
        });
        handleLogout(getLoggedOutEndpoint())
    }    
    else{
      setConfirmCancel(false);
      moveToReviewStep();
    }
  }

  if (hideNextButton) {
    if (!internalStatus || internalStatus == InternalApplicationStatuses.Draft) {
      return <>
        <SaveAndFinishLaterButton
          {...input}
        />
        <GoabSpacer vSpacing="3xl" />
      </>
    }
    return <></>
  }

  return (
    <>
      <GoabSpacer vSpacing="xl" />
      {!isTermsOfUse && !inReviewMode && canShowButtons && (
        <>
          <GoabButton
            type="primary"
            trailingIcon={nextButtonLabel ? "" : "arrow-forward"}
            testId="next-btn"
            disabled={!!disableNextButton && !templateForm.isValid }
            onClick={handleNext}
          >
            {getResourceValue({ key: nextButtonLabel ? "RESOURCES@" + nextButtonLabel : "RESOURCES@global.button.next", })}
          </GoabButton>
          {(!internalStatus || internalStatus == InternalApplicationStatuses.Draft) && 
            <SaveAndFinishLaterButton
              {...input}
            />
          }
          <GoabSpacer vSpacing="xl" />
        </>
      )}
      {isTermsOfUse && (
        <>
          <GoabButtonGroup alignment="start">
            <GoabButton
              type="tertiary"
              onClick={handleCancel}
            >
              {getResourceValue({ key: cancelButtonLabel ? "RESOURCES@" + cancelButtonLabel : "RESOURCES@global.button.cancel", })}
            </GoabButton>
            <GoabButton
              type="primary"
              trailingIcon="arrow-forward"
              testId="next-btn"
              onClick={handleNext}
            >
              {getResourceValue({ key: nextButtonLabel ? "RESOURCES@" + nextButtonLabel : "RESOURCES@global.button.next", })}
            </GoabButton>
          </GoabButtonGroup>
        </>
      )}

      {inReviewMode && (
        <>
          <GoabButtonGroup alignment="start">
            <GoabButton type="primary" testId="save-btn" onClick={handleSave} disabled={!templateForm.dirty}>
              {getResourceValue({ key: "RESOURCES@global.button.save", })}
            </GoabButton>

            <GoabButton type="secondary" onClick={onConfirmCancel}>
              {getResourceValue({ key: "RESOURCES@global.button.cancel", })}
            </GoabButton>
          </GoabButtonGroup>
          <GoabSpacer vSpacing="l" />
          <GoabModal heading={getResourceValue({ key: "RESOURCES@cancel.modal.header" })} role="alertdialog" open={confirmCancel}>
            {getResourceValue({ key: "RESOURCES@cancel.modal.content" })}
            <GoabButtonGroup alignment="end" mt="xl">
              <GoabButton type="secondary" onClick={() => setConfirmCancel(false)}>
                {getResourceValue({ key: "RESOURCES@global.button.cancel" })}
              </GoabButton>
              <GoabButton type="primary" onClick={onCancel}>
                {getResourceValue({ key: "RESOURCES@global.button.confirm" })}
              </GoabButton>
            </GoabButtonGroup>
          </GoabModal>
        </>
      )}
      <GoabSpacer vSpacing="3xl" />
    </>
  );
};

export default StepActionButtons;
